<template>
  <div class="error-page">
    <div class="main-wrapper">
      <div class="error-box">
        <h1>403</h1>
        <h3><i class="fa fa-warning"></i> Forbidden</h3>
        <p>You don't have permission to access this page</p>
        <router-link to="/" class="btn btn-custom">Back to Home</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'error403'
};
</script>
